import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";



export const PrinterListSlice = createSlice({
  name: "PrinterListSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PrinterList: (state) => {
      state.isLoading = true;
    },
    successPrinterList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePrinterList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPrinterList: (state) => {
      state.data = {};
    },
  },
});

export const {
  PrinterList,
  successPrinterList,
  failurePrinterList,
  clearPrinterList,
} = PrinterListSlice.actions;

export default PrinterListSlice.reducer;
